import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  paper: {
    fontFamily: `'Manrope', sans-serif`,
    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",
    justifyContent: "center",
    alignItems: "center",
    width: "45vw",
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    // padding: "1.5rem",
    [theme.breakpoints.down("md")]: {
      width: "55vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  modalBody: {
    height: "100%",
    width: "100%",
    position: "relative",
    "@media (min-height: 750px)": {
      overflowX: "hidden",
    },
    [theme.breakpoints.down("md")]: {
      overflowY: "scroll",
      overflowX: "hidden",
    },
    [theme.breakpoints.down("sm")]: {
      height: "70vh",
      overflowY: "scroll",
      overflowX: "hidden",
      paddingRight: ".55rem",
    },
    "& button": {
      fontFamily: `'Manrope', sans-serif`,
    },
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
    padding: "1.5rem",
    paddingBottom: 0,
  },
  modalHeaderTitle: {
    marginBottom: 8,
    fontSize: 20,
    lineHeight: "28px",
    color: "#344054",
    fontWeight: "bold",
  },
  modalHeaderSubtitle: {
    fontSize: 14,
    lineHeight: "24px",
    color: "#6F727A",
    fontWeight: "normal",
  },
  modalSection: {
    paddingTop: "1rem",
    width: "100%",
  },
  modalFooter: {
    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",
    background: "#F7F7F9",
    height: 80,
    borderRadius: "0 0 8px 8px",
    padding: "16px 1.5rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    "& div": {
      gap: "10px",
    },
  },
  modalBodyTitle: {
    color: "#465869",
    fontSize: 18,
    lineHeight: "18px",
    fontWeight: "bold",
    marginBottom: "15px",
  },
  inactiveItemIcon: {
    fontSize: 14,
    marginRight: 13,
  },
  containerInputRange: {
    marginTop: "0px !important",
  },
}));

export default styles;
